export const LOGIN_TYPE = ['Manual', 'Google', 'Apple'];
